import * as I18n from 'i18n-js';
import * as React from 'react';
import { get } from 'lodash';
import { V3 } from '../../api_request';
import CurationActions from '../actions/curation_actions';
import * as classNames from 'classnames';

interface IProps {
  listingId: string;
  admin?: {
    bumped?: boolean;
    curated_set_id?: string;
    featured_in_set?: boolean;
  };
}

interface IState {
  bumped: boolean;
  featuredInSet: boolean;
  bumpError: boolean;
  featureInSetError: boolean;
}

class TileCurationView extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = {
      bumped: get(this.props, 'admin.bumped'),
      featuredInSet: get(this.props, 'admin.featured_in_set') || false,
      bumpError: false,
      featureInSetError: false,
    };

    this.bumpListing = this.bumpListing.bind(this);
    this.toggleFeaturedInSet = this.toggleFeaturedInSet.bind(this);
    this.startCuration = this.startCuration.bind(this);
  }

  get href() {
    return `/admin/curated_sets/for_product/${this.props.listingId}`;
  }

  get bumpHref() {
    return `/admin/bumps/${this.props.listingId}/bump`;
  }

  get featureInSetHref() {
    const curatedSetId = this.props.admin.curated_set_id;
    const { listingId } = this.props;
    return `/admin/curated_sets/${curatedSetId}/feature?product_id=${listingId}`;
  }

  bumpListing(e) {
    e.preventDefault();
    e.stopPropagation();

    const req = V3.post(this.bumpHref).then(() => {
      this.setState({ bumped: true });
    });

    req.fail(() => {
      this.setState({ bumpError: true });
    });
  }

  toggleFeaturedInSet(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.state.featuredInSet) {
      this.unfeatureInSet();
    } else {
      this.featureInSet();
    }
  }

  featureInSet() {
    V3.post(this.featureInSetHref).done(() => {
      this.setState({ featuredInSet: true });
    }).fail(() => {
      this.setState({ featureInSetError: true });
    });
  }

  unfeatureInSet() {
    V3.destroy(this.featureInSetHref).done(() => {
      this.setState({ featuredInSet: false });
    }).fail(() => {
      this.setState({ featureInSetError: true });
    });
  }

  startCuration(e) {
    e.preventDefault();
    e.stopPropagation();

    CurationActions.fetchIndex({
      product_id: this.props.listingId,
    });
  }

  renderBumpButton() {
    if (this.state.bumpError) {
      return I18n.t('discovery.curation.error');
    }

    if (this.state.bumped) {
      return (
        <button
          className="button button--mini"
          data-disabled
        >
          {I18n.t('discovery.curation.bumped')}
        </button>
      );
    }

    return (
      <button
        onClick={this.bumpListing}
        className="button button--mini mb-half"
      >
        {I18n.t('discovery.curation.bumpButton')}
      </button>
    );
  }

  renderFeaturedSetControls() {
    if (!get(this.props, 'admin.curated_set_id')) { return null; }

    if (this.state.featureInSetError) {
      return (
        <div className="color-red">
          {I18n.t('discovery.curation.error')}
        </div>
      );
    }

    const text = this.state.featuredInSet ?
      I18n.t('discovery.curation.featuredInSet') : I18n.t('discovery.curation.feature');

    return (
      <button
        className="button button--mini mb-half"
        onClick={this.toggleFeaturedInSet}
        data-featured-button
      >
        <span className={classNames({ 'icon-l-check': this.state.featuredInSet })}>
          {text}
        </span>
      </button>
    );
  }

  render() {
    return (
      <div className="bdt-1 bd--offwhite plr-half pt-half">
        <div className="d-flex fx-justify-between fx-wrap width-100">
          <button
            className="button button--mini mb-half"
            onClick={this.startCuration}
          >
            {I18n.t('discovery.curation.curateButton')}
          </button>
          {this.renderBumpButton()}
          {this.renderFeaturedSetControls()}
        </div>
      </div>
    );
  }
}

export default TileCurationView;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/curation/tile_curation_view.tsx